<template>
  <section class="section section--flush" id="process">
    <div class="wrap">
      <div class="sec-head reveal" v-reveal>
        <p class="sec-eyebrow">03 / PROCESS / 流程</p>
        <h2>怎么跟我们合作</h2>
        <p>四步推进, 每一步都有你能亲眼看到的东西。</p>
      </div>
      <div class="steps">
        <div class="step reveal" v-reveal>
          <p class="step-num">STEP 01</p>
          <h3>需求诊断</h3>
          <p>把你的需求拆成「能做到」和「做不到」两张清单, 做不到的不接。</p>
        </div>
        <div class="step reveal" v-reveal>
          <p class="step-num">STEP 02</p>
          <h3>原型验证</h3>
          <p>一周内交出能跑的原型。你亲眼看到效果, 再决定要不要做下去。</p>
        </div>
        <div class="step reveal" v-reveal>
          <p class="step-num">STEP 03</p>
          <h3>交付上线</h3>
          <p>系统 + 文档 + 一次培训。你的团队接得住, 才算交付完。</p>
        </div>
        <div class="step reveal" v-reveal>
          <p class="step-num">STEP 04</p>
          <h3>陪跑迭代</h3>
          <p>上线后 30 天, 提示词、知识库、流程, 随时调整。</p>
        </div>
      </div>
      <p class="step-note reveal" v-reveal><strong>为什么能这么快？</strong> 因为我们是一个 AI 驱动的组织, 每个岗位都有自己的 AI 搭档。</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProcessSection'
}
</script>

<style scoped>
.steps {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.step {
  border-top: 2px solid var(--ink);
  padding-top: 20px;
}

.step-num {
  font-family: var(--mono);
  font-size: 12px;
  color: var(--accent);
  margin-bottom: 12px;
}

.step h3 {
  font-size: 16.5px;
  font-weight: 600;
  margin-bottom: 8px;
}

.step p {
  font-size: 13.5px;
  color: var(--ink-2);
}

.step-note {
  margin-top: 28px;
  padding: 16px 20px;
  background: var(--accent-soft);
  border-radius: 10px;
  font-size: 14px;
  color: var(--ink-2);
}

.step-note strong {
  color: var(--ink);
  font-weight: 500;
}

@media (max-width: 860px) {
  .steps {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
